import {
	ErrorMessage,
	ErrorMessageCodes,
	errorMessageCodes,
	OTHER_ERROR_MESSAGE_I18N_KEY,
} from 'types/ErrorMessage';

import { extractTransferFailureReason } from 'util/travelTransfer';

const backendMessageMap: { [message: string]: ErrorMessageCodes } = {
	'duplicate order': ErrorMessage.DUPLICATE_ORDER,
	// issue PM_template#3009：FormRequest 驗證失敗（例如電話格式）時，後端固定回傳
	// `message: 'validation error'`，跟 controller 層的業務錯誤碼是不同形狀的回應，
	// 先前沒有對應到任何已知代碼，一律 fallback 顯示「系統異常，請聯絡管理員」，
	// 讓使用者誤以為是系統故障而非自己填寫的格式有誤。
	'validation error': ErrorMessage.THE_GIVEN_DATA_WAS_INVALID,
	// issue PM_template#3011/#3013：後端 `validateTransferredOriginalOrder` 判定原訂單不可轉團
	// （不存在、已取消、已轉團）時回傳，此時沒有 data.reason。
	'validate transferred original order error': ErrorMessage.TRANSFER_ORIGINAL_ORDER_INVALID,
};

export const normalizeTravelOrderMessage = (
	message: unknown,
): ErrorMessageCodes | typeof OTHER_ERROR_MESSAGE_I18N_KEY => {
	const normalizedMessage =
		typeof message === 'string' ? backendMessageMap[message] || message : message;

	return errorMessageCodes.includes(normalizedMessage as ErrorMessageCodes)
		? (normalizedMessage as ErrorMessageCodes)
		: OTHER_ERROR_MESSAGE_I18N_KEY;
};

/**
 * 依後端回應的 message 與 data 決定要顯示的錯誤代碼。
 *
 * 旅遊轉團 transfer token 驗證失敗時，後端的 message 是 `validate transferred original order error`（422）
 * 或 `validate transfer token failed.`（400），真正的原因在 data：
 * - 422：`data.reason`
 * - 400（交易內消耗 token 的競態）：`data` 本身就是原因字串
 * 因此必須先看 data，不能只看 message，否則所有原因都會落到通用的「系統異常」。
 */
export const normalizeTravelOrderError = (
	message: unknown,
	data: unknown,
): ErrorMessageCodes | typeof OTHER_ERROR_MESSAGE_I18N_KEY => {
	const transferFailureReason = extractTransferFailureReason(data);

	if (transferFailureReason) {
		return transferFailureReason === 'ITINERARY_MISMATCH'
			? ErrorMessage.TRANSFER_ITINERARY_MISMATCH
			: ErrorMessage.TRANSFER_TOKEN_INVALID;
	}

	return normalizeTravelOrderMessage(message);
};
